<template>
  <form ref="form" class="white-box" v-bind:data-auth-token="organization.auth_token">
    <div class="row">
      <div class="field">
        <label>Organization Name</label>
        <input type="text" placeholder="Company Name" class="large" name="organization_name" v-bind:value="organization.organization_name" />
      </div>
      <div class="field">
        <label>Email</label>
        <input type="email" placeholder="email@example.com" name="email" v-bind:value="organization.email"></div>
      </div>
      <div class="row">
        <div class="field">
          <label>Description</label>
          <textarea name="description" placeholder="A short description of your organization.">{{ organization.description }}</textarea>
        </div>
      </div>
      <button type="button" class="shadow shadow--small" @click="submit">Update Information</button>
  </form>
</template>

<script>
import utils from "@/js/utils";
import request from "@/js/request";

export default {
  name: `OrganizationSettingsForm`,
  props: ["organization"],
  methods: {
    async submit () {
      const { form } = this.$refs;

      if (form.checkValidity() === true) {
        const data = utils.getFormInput(form);

        let response = await request(`http://localhost:3000/api/v1/organizations/me/`, {
          headers: {
            Authorization: `Basic ${form.dataset.authToken}`,
          },
        }).put(data);

        console.log(response);
      }
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/special/OrganizationSettingsForm.vue